import { Box, Typography, Stack, StackProps, ButtonGroup, Button, Grid } from '@mui/material';
import MoreOptionMenu, { MoreOptionMenuProps } from 'components/Dropdown/MoreOptionSecondary';
import DateInfoTooltip, { DateInfoTooltipProps } from 'components/Tooltip/DateInfoTooltip';
import { ReactComponent as InfoGreyIcon } from '../../assets/icon-grey-info.svg';
import { ReactComponent as MoreIcon } from '../../assets/more-vertical.svg';
import { ReactComponent as PlusIcon } from '../../assets/plus-icon.svg';
import { Link } from 'react-router-dom';

type SLAItemType ={
		label: string;
		count: number;
		onBtnClick: (event?: any) => void;
	}

type TitleStatusProps = {
	title: string;
	isEditEnabled?: boolean;
	programId: string;
	projectCount: number;
	projectSLAs?: SLAItemType[];
	programSLAs?: SLAItemType[];
	statusCount?: number;
	programStatusCount?: number;
	bgColor?: string;

	minTitleHeight?: `${number}px`;
	hasTooltip?: boolean;

	infoTooltip?: Omit<DateInfoTooltipProps, 'children'>;
	infoOptionMenu?: MoreOptionMenuProps;

	onClickAddProject?: (event: any) => void;

	handleEvent?: () => void;
	ratioNumber?: {
		number: number | string;
		totalNumber: number | string;
	};
	containerProps?: StackProps;
};


const TitleStatus = ({
	bgColor = 'primary.main',
	title = '',
	programId,
	projectCount,
	projectSLAs,
	programSLAs,
	statusCount,
	programStatusCount,
	minTitleHeight = '45px',
	infoTooltip,
	infoOptionMenu,
	isEditEnabled,
	handleEvent,
	onClickAddProject,
	containerProps,
}: Readonly<TitleStatusProps>) => {
	const getSLAClassName = (label: string): string => {
		if (label === 'SLA Missed') {
			return 'color-missed';
		}

		if (label === 'SLA Met') {
			return 'color-met';
		}

		if (label === 'In Progress') {
			return 'color-progress';
		}

		if (label === 'Scheduled') {
			return 'color-scheduled';
		}

		return 'color-others';
	};
	return (
		<Box
			display="flex"
			flexGrow={1}
			height="100%"
			width="100%"
			position="relative"
			{...(handleEvent && { onClick: handleEvent, sx: { cursor: 'pointer' } })}
		>
			<Stack
				minHeight="100px"
				p={2}
				bgcolor={bgColor}
				fontFamily="Montserrat"
				borderRadius="5px"
				flexGrow={1}
				width="90%"
				{...containerProps}
				sx={{
					position: 'relative',
					'&:hover .hover-content': {
						opacity: 1
					},
					...containerProps?.sx,
				}}
			>
				<Stack minHeight={minTitleHeight}>
					<Grid container spacing={2}>
						<Grid item xs={10}>
							<Typography variant="widgetTitle" style={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', display: 'inline-block'}} sx={{'& a': {color: '#eee'}}}>
								<Link title={title} to={`/data-pipeline/ibp-dashboard/programs/${programId}/${encodeURIComponent(title)}`} style={{color: '#e5e5e5', textDecoration: 'none', transition: 'color 0.3s ease'}} onMouseEnter={(e) => (e.currentTarget.style.color = '#009BD8')} onMouseLeave={(e) => (e.currentTarget.style.color = '#e5e5e5')}>{title}</Link>
							</Typography>
						</Grid>
						<Grid item xs={2}>
							<Box sx={{ textAlign: 'center', '& .MuiIconButton-root': { verticalAlign: 'top', paddingLeft: '15px', height: '24px'}}}>
								{!!infoTooltip && (
									<DateInfoTooltip {...infoTooltip}>
										<InfoGreyIcon />
									</DateInfoTooltip>
								)}
								{!!infoOptionMenu && isEditEnabled && (
									<MoreOptionMenu {...infoOptionMenu}>
										<MoreIcon />
									</MoreOptionMenu>
								)}
							</Box>
						</Grid>
					</Grid>
				</Stack>
				<Stack minHeight="20px" flexGrow={1} justifyContent="center">
				
					{projectCount > 0 && <>
						{window.location.pathname.includes('ibp') && (
							<Box sx={{display: 'flex', justifyContent: 'space-between'}}>
							<Stack sx={{ mt: 1, mb: 1 }}>
								<Typography variant="footerSubtitle" style={{ color: 'rgba(245, 245, 245, 1)' }}>
									Execution Time: {new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replace(/\//g, '-')} 02:00 (CST)
								</Typography>
								<Typography variant="footerSubtitle" style={{ color: 'rgba(245, 245, 245, 1)' }}>
									Next Execution: {new Date(Date.now() + 86400000).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replace(/\//g, '-')} (CST)
								</Typography>
							</Stack>
							<Grid sx={{	display: 'flex', alignItems: 'center'}}>
								{programSLAs?.find(sla => sla.count === 1)?.label && <Grid sx={{
									backgroundColor: (programSLAs?.find(sla => sla.count === 1)?.label || programSLAs?.[0]?.label) === 'SLA Missed' ? 'rgba(216, 43, 81, 1)' :
										(programSLAs?.find(sla => sla.count === 1)?.label || programSLAs?.[0]?.label) === 'SLA Met' ? 'rgba(1, 192, 8, 1)' :
										(programSLAs?.find(sla => sla.count === 1)?.label || programSLAs?.[0]?.label) === 'Scheduled' ? 'rgba(169, 173, 203, 1)' :
										(programSLAs?.find(sla => sla.count === 1)?.label || programSLAs?.[0]?.label) === 'In Progress' ? 'rgba(236, 185, 20, 1)' :
										'rgba(236, 185, 20, 1)',
									padding: '6px',
									borderRadius: '4px',
								}}>
									<Typography variant="footerSubtitle" style={{color: 'rgba(245, 245, 245, 1)'}}>
										{programSLAs?.find(sla => sla.count === 1)?.label || ''}
									</Typography>
								</Grid>}
							</Grid>
							</Box>
						)}
						<Box sx={{display: 'flex', justifyContent: 'space-between'}}>
							{window.location.pathname.includes('ibp') ? (
								<Typography variant="footerSubtitle" mb={1} style={{color: 'rgba(245, 245, 245, 1)'}}>Stage SLAs</Typography>
							) : (
								<Typography variant="footerSubtitle" mb={1} style={{color: 'rgba(245, 245, 245, 1)'}}>Projects SLAs</Typography>
							)}
							{window.location.pathname.includes('ibp') ? (
								<Typography variant="footerSubtitle" mb={1} style={{color: 'rgba(255, 255, 255, 1)'}}>Total GDO Stages {projectCount}</Typography>
							) : (
								<Typography variant="footerSubtitle" mb={1} style={{color: 'rgba(255, 255, 255, 1)'}}>Total Projects {projectCount}</Typography>
							)}
						</Box>
						<ButtonGroup sx={{
							boxShadow: 'none',
							'& button': {
								variant: 'pepwiseButtonText',
								borderRadius: '4px',
								color: '#fff',
								padding: '5px',
								overflow: 'hidden',
								height: '32px',
								width: '100px',
								textTransform: 'uppercase',
								transitionProperty: 'width, opacity',
								transitionDuration: '0.3s',
								transitionTimingFunction: 'ease-out, ease-in',
								transitionDelay: '0s, 0.05s',
							},
							'& .toggle-label': {
								width: 0,
								marginLeft: '8px',
								opacity: 0
							},
							'& button:hover': {
								width: '150px'
							},
							'& button:hover .toggle-label': {
								width: 'auto',
								transitionProperty: 'width, opacity',
								transitionDuration: '0.3s',
								transitionTimingFunction: 'ease-out, ease-in',
								transitionDelay: '0s, 0.1s',
								opacity: 1
							},
							'& .color-missed': {
								backgroundColor: 'rgba(216, 43, 81, 1)',
								'&:hover': {
									backgroundColor: 'rgb(189, 29, 64)'
								}
							},
							'& .color-met': {
								backgroundColor: 'rgba(1, 192, 8, 1)',
								'&:hover': {
									backgroundColor: 'rgb(3, 168, 8)'
								}
							},
							'& .color-scheduled': {
								backgroundColor: 'rgba(169, 173, 203, 1)',
								'&:hover': {
									backgroundColor: 'rgba(163, 168, 200, 1)'
								}
							},
							'& .color-others': {
								backgroundColor: 'rgba(236, 185, 20, 1)',
								'&:hover': {
									backgroundColor: 'rgb(220, 171, 10)'
								}
							},
							'& .color-progress': {
								backgroundColor: 'rgba(236, 185, 20, 1)',
								'&:hover': {
									backgroundColor: 'rgba(236, 185, 20, 1)',
								
								}
							}
						}}>
							
							{projectSLAs?.map(({ label, count, onBtnClick }) => (
								count && <Button
									variant='pepwiseButtonText'
									className={getSLAClassName(label)}
									key={label}
									onClick={(event) => {
										onBtnClick('menuItem');
									}}
								>{count} {' '} <span className='toggle-label'>{ label }</span></Button>
							))}
						</ButtonGroup>
						{ !statusCount ? <Typography variant="tableColumnFont">No Data</Typography> : '' }
					</>
					}
					
					{isEditEnabled && projectCount == 0 && <Button
						variant='pepwiseButtonText'
						sx={{
							border: '1px solid #009BD8',
							borderRadius: '5px',
							color: '#009BD8',
							width: '160px',
							'& svg path': {
								fill: '#009BD8'
							},
							'&:hover': {

							}
						}}
						onClick={onClickAddProject}
					><PlusIcon /> ADD PROJECT</Button>
					}
				</Stack>
			</Stack>
		</Box>
	);
};

export default TitleStatus;
